import { render } from "./CollectionsReportPage.vue?vue&type=template&id=597fbe12&scoped=true"
import script from "./CollectionsReportPage.vue?vue&type=script&lang=js"
export * from "./CollectionsReportPage.vue?vue&type=script&lang=js"

import "./CollectionsReportPage.vue?vue&type=style&index=0&id=597fbe12&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597fbe12"]])

export default __exports__